"use strict";


const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");
const typography = require("!!css-loader!../../tokens/typography.css").default;

class Element extends HTMLElement {


    constructor(template) {
        super();

        this.root = this.attachShadow({ mode: "closed" });

        /**
         * Applying styles inside the shadow DOM:
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_shadow_DOM#applying_styles_inside_the_shadow_dom
         */
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(typography);
        this.root.adoptedStyleSheets = [sheet];

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.container = this.root.querySelector(".swiftref-badge");

    }


    static get observedAttributes() {
        return ["value"];
    }

    get clear_icon() {
        return this.hasAttribute("clear_icon");
    }
    set clear_icon(value) {
        this.setAttribute("clear_icon", "");
    }
    get value() {
        return this.getAttribute("value");
    }
    set value(value) {
        this.setAttribute("value", value);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "value") {
            this.render(newValue);
        }
    }

    connectedCallback() {
        this.render(this.innerHTML);
    }

    render(value) {
        if (value) {
            this.container.innerText = value.toString();
            this.container.style.visibility = "visible";
            // if the content is a text, uses different border-radius

            // When the badge is used as a filter,even if it's a number,
            // we want to add the 'caption' class. Example: in microservices_eds_node.

            if (isNaN(this.container.innerText) || this.hasAttribute("data-filter-name")) {
                this.container.classList.add("text");
                this.container.classList.add("caption");

                if (this.clear_icon) {
                    const clearIcon = document.createElement("span");
                    clearIcon.innerText = "x";
                    clearIcon.className = "clear-icon";
                    clearIcon.addEventListener("click", this.removeTag.bind(this));
                    this.container.appendChild(clearIcon);
                }

            } else {
                // number has custom font
                this.container.classList.add("caption-b");

            }
        }
    }

    removeTag(event) {
        this.dispatchEvent(new CustomEvent("remove", {
            bubbles: true
            // composed: true
        }))
    }

}

window.customElements.define("swiftref-badge", Element);

module.exports = Element;
